import { Trans, useTranslation } from "react-i18next";

import { LogoType } from "../../../../commons/types/logo";
import * as icons from "../../../../resources/icons";
import Headline from "../../../commons/components/Headline/Headline";
import Hotline from "../../../commons/components/Hotline/Hotline";
import Icon from "../../../commons/components/Icon/Icon";
import IconLink from "../../../commons/components/IconLink/IconLink";
import InformationPageLayout from "../../../commons/components/InformationPageLayout/InformationPageLayout";
import Paragraph from "../../../commons/components/Paragraph/Paragraph";
import SplitContentLayout from "../../../commons/components/SplitContentLayout/SplitContentLayout";
import Text from "../../../commons/components/Text/Text";
import LogoPartial from "../../../commons/container/App/LogoPartial";
import { useAppHistory } from "../../../commons/libs/hooks/use-app-routing";
import { ROUTES } from "../../../commons/routes";
import { useMobileAppDispatcher, useMobileAppSelector } from "../../store/hooks";
import DeviceInformationPartial from "../App/DeviceInformationPartial";

const SupportPage = () => {
  const hasEnteredThroughDeepLink = useMobileAppSelector(state => state.mobile?.hasEnteredThroughDeepLink);
  const [dispatch, actions] = useMobileAppDispatcher();
  const { t } = useTranslation(["mobile"]);
  const history = useAppHistory();

  const renderBackButton = () => {
    const onClick = () => {
      // To prevent a mobile user from accidentally exiting the app when he enters through a deep link,
      // we redirect in place (don't push), to the main page to start a new history
      if (hasEnteredThroughDeepLink) {
        // We reset the hasEnteredThroughDeepLink-state to prevent a loop
        dispatch(actions.mobile.setHasEnteredThroughDeepLink(false));
        history.replace(ROUTES.NAVIGATION.INDEX);
      } else {
        history.goBack();
      }
    };

    const label = hasEnteredThroughDeepLink
      ? t("mobile:deviceInformationAndSupportPage.backToMainMenuButton")
      : t("mobile:deviceInformationAndSupportPage.backButton");

    return (
      <IconLink icon={<Icon source={icons.IconSmallArrowLeft} />} size="l" variant="standout" onClick={onClick}>
        {label}
      </IconLink>
    );
  };

  return (
    <InformationPageLayout
      variant="standout"
      headerLeft={renderBackButton()}
      headerRight={<LogoPartial type={LogoType.BcIconInvert} />}
    >
      <Text>
        <Headline kind="hero">
          <Trans
            t={t}
            i18nKey="mobile:deviceInformationAndSupportPage.contactSupportHeadline"
            components={{
              linebreak: <br />
            }}
          />
        </Headline>
        <Paragraph>{t("mobile:deviceInformationAndSupportPage.contactExplanation")}</Paragraph>
        <br />
        <br />
        <SplitContentLayout size="s">
          <Hotline
            title={t("mobile:supportConfig.headline")}
            phone={t("mobile:supportConfig.phone")}
            label={t("mobile:supportConfig.officeHours")}
            mail={t("mobile:supportConfig.mail")}
          />
          <DeviceInformationPartial informationListVariant="standout" />
        </SplitContentLayout>
      </Text>
    </InformationPageLayout>
  );
};

export default SupportPage;
